export default "__VITE_ASSET__BPSoa6cV__"